import {
  Card,
  Row,
  Col,
  Form,
  InputNumber,
  Select,
  Input,
  Checkbox,
  Button
} from 'antd';
import { headerStyle } from 'shared/styles/baseStyle';
import Validations from 'shared/validations/Validations.json';

export default function PackingForm({
  isNewPackageFormDisable,
  onFinish,
  form,
  carrierCompany,
  deviceType,
  isDisplayPackageId,
  submitButtonName,
  isNewChecked,
  isDisabledOBDType,
  useNewSIM,
  isNewOnChangeValue,
  handleIsNewChanged,
  isDisplayUseNewSIM,
  isVisibleContinueButton,
  navigateToNewDeviceForm,
  isVisibleUpdateButton,
  isNewButtomDisabled,
  isCarrierCompanyDisabled,
  isBarcodePrintDisabled,
  isNewUseSIMDisable,
   deviceTypeId
}) {
  const { Option } = Select;
  const PCL = 3 ;
  const layout = {
    labelCol: {
      span: 14
    },
    wrapperCol: {
      span: 6
    }
  };

 
  return (
    <Card
      type="inner"
      headStyle={headerStyle}
      title="Στοιχεία Κιβωτίου"
    >
      <Form form={form} onFinish={onFinish} {...layout}>
        <Row>
          <Col span={12}>
            <Form.Item
              name="capacity"
              label="Σύνολο Συσκευασιών Κιβωτίου"
              rules={[
                {
                  type: 'number',
                  min: 1,
                  message: Validations.PACKINGCAPACITY.RANGEMESSAGE
                },
                {
                  required: true,
                  message: Validations.PACKINGCAPACITY.REQUIREDMESSAGE
                }
              ]}
            >
              <InputNumber disabled={isNewPackageFormDisable} size="middle" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              wrapperCol={{ span: 3 }}
              name="remainingCapacity"
              label="Σύνολο κιβωτίου που απομένει:"
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="deviceType"
              label={
                 deviceTypeId === PCL
                  ? 'Μοντέλο Bluetooth Συσκευής'
                  : 'Μοντέλο OBD Συσκευής'
              }
              rules={[
                {
                  required: true,
                  message: Validations.GLOBALREQUIREDMESSAGE.MESSAGE
                }
              ]}
            >
              <Select disabled={isDisabledOBDType}>
                {deviceType?.map(typeObdDeviceItem => (
                  <Option
                    key={typeObdDeviceItem.id}
                    id={typeObdDeviceItem.name}
                    value={typeObdDeviceItem.id}
                  >
                    {typeObdDeviceItem.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          { deviceTypeId < PCL && (
            <Col span={12}>
              <Form.Item
                name="carrierCompany"
                label="Εταιρεία Κινητής Τηλεφωνίας"
                rules={[
                  {
                    required: true,
                    message: Validations.GLOBALREQUIREDMESSAGE.MESSAGE
                  }
                ]}
              >
                <Select
                  disabled={isNewPackageFormDisable || isCarrierCompanyDisabled}
                >
                  {carrierCompany?.map(mobileServiceProviderItem => (
                    <Option
                      key={mobileServiceProviderItem.id}
                      id={mobileServiceProviderItem.name}
                      value={mobileServiceProviderItem.id}
                    >
                      {mobileServiceProviderItem.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
          <Col span={12}>
            <Form.Item
              initialValue={false}
              valuePropName="checked"
              name="barcodePrint"
              label="Εκτύπωση Barcode:"
            >
              <Checkbox
                disabled={isNewPackageFormDisable || isBarcodePrintDisabled}
              />
            </Form.Item>
          </Col>
            <Col span={12}>
              <Form.Item
                initialValue={isNewChecked}
                valuePropName="checked"
                name="isNew"
                label={ deviceTypeId === PCL
                  ? 'Επαναπρογραμματισμός Bluetooth:'
                  : 'Επαναπρογραμματισμός OBD:'}
              >
                <Checkbox
                  onChange={handleIsNewChanged}
                  checked={isNewChecked}
                  disabled={isNewPackageFormDisable || isNewButtomDisabled}
                />
              </Form.Item>
            </Col>
          {  deviceTypeId < PCL && (isNewOnChangeValue === true || isDisplayUseNewSIM === false) && (
            <Col offset={12} span={12}>
              <Form.Item
                initialValue={useNewSIM}
                valuePropName="checked"
                name="useNewSIM"
                label="Χρήση νέας SIM"
              >
                <Checkbox
                  checked={useNewSIM}
                  disabled={isNewPackageFormDisable || isNewUseSIMDisable}
                />
              </Form.Item>
            </Col>
          )}
          {isDisplayPackageId ? (
            <Col span={12}>
              <Form.Item name="PackageId" label="Κωδικός Κιβωτίου">
                <Input disabled />
              </Form.Item>
            </Col>
          ) : null}
          {isVisibleUpdateButton ? (
            <Col span={12} offset={12}>
              <Form.Item>
                <Button
                  disabled={isNewPackageFormDisable}
                  style={{ backgroundColor: '#e6e6e6' }}
                  htmlType="submit"
                >
                  {submitButtonName}
                </Button>
              </Form.Item>
            </Col>
          ) : null}
          {isVisibleContinueButton ? (
            <Col span={12} offset={12}>
              <Form.Item>
                <Button
                  style={{ backgroundColor: '#e6e6e6' }}
                  htmlType="button"
                  onClick={navigateToNewDeviceForm}
                >
                  Συνέχεια
                </Button>
              </Form.Item>
            </Col>
          ) : null}
        </Row>
      </Form>
    </Card>
  );
}
